<template>
    <div v-html="stripHtml(currentInfo)"></div>
</template>

<script>
	export default {
		name: 'profileInfo',
		props: {
            info: String
        },
         data: function() {
        	return {
                currentInfo: null
        	}
        },
        created: function() {
            var self = this;
            this.currentInfo = this.info;
            this.$bus.$on('changedInfo', ($event) => {
                this.currentInfo = $event;
            });
        },
        methods: {
            stripHtml: function(value) {
                var div = document.createElement("div");
                div.innerHTML = value;
                var text = div.textContent || div.innerText || "";
                return text;
            }
        }
	}
</script>


// WEBPACK FOOTER //
// ProfileInfo.vue?4bcac25e